import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "btn2",
  "use": "btn2-usage",
  "viewBox": "0 0 71 129",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 71 129\" id=\"btn2\"><path fill-rule=\"evenodd\" d=\"M8.000,-0.000 L63.000,-0.000 C67.418,-0.000 71.000,3.582 71.000,8.000 L71.000,121.000 C71.000,125.418 67.418,129.000 63.000,129.000 L8.000,129.000 C3.582,129.000 -0.000,125.418 -0.000,121.000 L-0.000,8.000 C-0.000,3.582 3.582,-0.000 8.000,-0.000 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol